import React from "react";
import { hydrate } from "react-dom";
import { loadableReady } from "@loadable/component";
import { createInstance } from "@optimizely/react-sdk";
import createStore from "store/create";
import initialize from "utils/app/initialize";
import App from "containers/App";

// Create the store from the state injected via the server-generated HTML

const decodedState = window.__PRELOADED_STATE__
	? JSON.parse(atob(window.__PRELOADED_STATE__, "base64"))
	: null;

const store = createStore(decodedState);

const datafileFromServer = window.__OPTIMIZELY_DATAFILE__;
const userFromServer = window.__OPTIMIZELY_USER__;

let optimizelyClient = null;
if (datafileFromServer) {
	try {
		optimizelyClient = createInstance({
			datafile: datafileFromServer
		});
	} catch (err) {
		console.error("[Optimizely] Client initialization error:", err);
	}
}

// Initialize segment
initialize(store);

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;

// remove the `#preloaded-state` element
const preloadedStateElement = document.getElementById("preloadedState");
if (preloadedStateElement) {
	preloadedStateElement.remove();
}

const render = (AppComponent) =>
	hydrate(
		<AppComponent
			store={store}
			optimizelyClient={optimizelyClient}
			optimizelyUser={userFromServer}
		/>,
		document.getElementById("app")
	);

(async () => {
	if (optimizelyClient) {
		try {
			const userId = userFromServer?.id || store.getState().user.visitId;
			optimizelyClient.setUser({
				id: userId,
				attributes: userFromServer?.attributes
			});

			await optimizelyClient.onReady({ timeout: 1000 });
		} catch (err) {
			console.warn(
				"[Optimizely] SDK ready timeout, hydrating anyway:",
				err
			);
		}
	}

	loadableReady(() => render(App));

	delete window.__OPTIMIZELY_DATAFILE__;
	delete window.__OPTIMIZELY_USER__;
})();

if (module.hot) {
	module.hot.accept(["./containers/App"], () => {
		const NextApp =
			require("./containers/App").default; /* eslint-disable-line global-require, max-len */
		render(NextApp);
	});
}
